import { Reveal } from "@/components/Reveal";
import { Camera, Handshake, Megaphone, TrendingUp } from "lucide-react";

const services = [
  {
    icon: Camera,
    title: "Profile Building",
    desc: "Editorial-grade portfolios, digitals, and a story that makes you unforgettable in a scroll.",
  },
  {
    icon: Handshake,
    title: "Brand Matching",
    desc: "We connect your look and values with the right labels — from emerging houses to global names.",
  },
  {
    icon: Megaphone,
    title: "Campaign Management",
    desc: "Bookings, call sheets, contracts and logistics handled, so you just show up and shine.",
  },
  {
    icon: TrendingUp,
    title: "Ambassadorships",
    desc: "Long-term partnerships and paid ambassador roles that turn a face into a recognisable brand.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#0a0a0a] text-[#ffffff] py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-12 bg-[#ffffff]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#ffffff]/60">
              What We Do
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-none max-w-3xl">
            Everything between <span className="italic">raw talent</span> and a career.
          </h2>
          <p className="font-script text-[#ffffff] text-4xl md:text-6xl leading-none mt-6">
            we handle the hustle — you handle the room.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-white/15">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.08}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative border-r border-b border-white/15 p-8 md:p-10 min-h-[300px] flex flex-col justify-between hover:bg-[#000000] transition-colors duration-500"
                >
                  <div className="flex items-start justify-between">
                    <Icon size={36} strokeWidth={1} className="text-[#ffffff] group-hover:text-white transition-colors duration-500" />
                    <span className="font-display text-2xl text-white/20 group-hover:text-white/40 transition-colors duration-500">
                      0{i + 1}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl font-medium mb-4">
                      {s.title}
                    </h3>
                    <p className="text-sm md:text-base text-[#ffffff]/60 group-hover:text-white/90 leading-relaxed transition-colors duration-500">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
